export function playSound(soundId) {
    const sound = document.getElementById(soundId);
    if (sound) {
        sound.play();
    }
}

export function handleClickSound(soundId, callback) {
    return function (event) {
        playSound(soundId);

        if (callback) {
            callback(event);
        }
    }
}